import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "ml-4 mr-4"
}

import { ComputedRef, computed, WritableComputedRef } from "vue";
import { useStore } from "vuex";
import TwLabel from "../TwLabel.vue";
import TwTextarea from "../TwTextarea.vue";
import TwButtonsYesAndNo from "../TwButtonsYesAndNo.vue";


export default /*#__PURE__*/_defineComponent({
  __name: '3.CurrentlyUseAccutaneAndOthers',
  setup(__props) {

const store = useStore();

const currentlyUseAccutaneAndOthers: ComputedRef<boolean> = computed(
  () => store.state.form.currently_use_accutane_and_others
);
const currentlyUseAccutaneAndOthersWhichOnes: WritableComputedRef<string> =
  computed({
    get: () => store.state.form.currently_use_accutane_and_others_which_ones,
    set: (value) =>
      store.dispatch("updateCurrentlyUseAccutaneAndOthersWhichOnes", value),
  });
const currentlyUseAccutaneAndOthersHowLong: WritableComputedRef<string> =
  computed({
    get: () => store.state.form.currently_use_accutane_and_others_how_long,
    set: (value) =>
      store.dispatch("updateCurrentlyUseAccutaneAndOthersHowLong", value),
  });

const updateCurrentlyUseAccutaneAndOthers = (value: boolean) => {
  store.dispatch("updateCurrentlyUseAccutaneAndOthers", value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([[currentlyUseAccutaneAndOthers.value == null ? 'bg-red-500' : ''], "p-2"])
  }, [
    _createVNode(TwLabel, null, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t("currently_use_accutane_and_others")), 1)
      ]),
      _: 1
    }),
    _createVNode(TwButtonsYesAndNo, {
      isActive: currentlyUseAccutaneAndOthers.value,
      onOnClickYes: _cache[0] || (_cache[0] = ($event: any) => (updateCurrentlyUseAccutaneAndOthers(true))),
      onOnClickNo: _cache[1] || (_cache[1] = ($event: any) => (updateCurrentlyUseAccutaneAndOthers(false)))
    }, null, 8, ["isActive"]),
    (currentlyUseAccutaneAndOthers.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(TwLabel, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("which_ones")), 1)
            ]),
            _: 1
          }),
          _createVNode(TwTextarea, {
            modelValue: currentlyUseAccutaneAndOthersWhichOnes.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((currentlyUseAccutaneAndOthersWhichOnes).value = $event)),
            rows: 2,
            id: "currentlyUseAccutaneAndOthersWhichOnes"
          }, null, 8, ["modelValue"]),
          _createVNode(TwLabel, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("how_long")), 1)
            ]),
            _: 1
          }),
          _createVNode(TwTextarea, {
            modelValue: currentlyUseAccutaneAndOthersHowLong.value,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((currentlyUseAccutaneAndOthersHowLong).value = $event)),
            rows: 2,
            id: "currentlyUseAccutaneAndOthersHowLong"
          }, null, 8, ["modelValue"])
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})